// src/components/AppShowcase.js
import React from "react";
import styled, { keyframes } from "styled-components";
import { motion } from "framer-motion";
import Lottie from "lottie-react";

/* LOAD JSON FROM PUBLIC FOLDER */
const AppShowcase = () => {
  const [animationData, setAnimationData] = React.useState(null);

  React.useEffect(() => {
    fetch("/animations/Robot-Bot 3D.json")
      .then((res) => res.json())
      .then((data) => setAnimationData(data))
      .catch((err) => console.error("Error loading Lottie JSON:", err));
  }, []);

  return (
    <Section id="showcase">
      <LeftLottieContainer
        initial={{ opacity: 0, x: -25 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        {animationData && (
          <Lottie
            animationData={animationData}
            loop
            className="lottie"
          />
        )}
      </LeftLottieContainer>

      <RightContent
        initial={{ opacity: 0, x: 25 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <Title>
          Smarter Trading Starts with <span>You</span>
        </Title>

        <Subtitle>
          Get real-time insights, AI-driven signals, and a clean interface
          designed to help you trade confidently.
        </Subtitle>

        <BulletList>
          <li>✔ Real-time AI recommendations</li>
          <li>✔ Personalized watchlists</li>
          <li>✔ Clean, fast, beginner-friendly interface</li>
        </BulletList>

        <CTAButtons>
          <PrimaryCTA
            href="https://play.google.com/store/apps/details?id=com.entiresolutions.trendgenie"
            target="_blank"
          >
            Download the App
          </PrimaryCTA>

          <SecondaryCTA href="#features">Learn More</SecondaryCTA>
        </CTAButtons>
      </RightContent>
    </Section>
  );
};

/* ---- STYLES BELOW (unchanged) ---- */

const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const Section = styled.section`
  padding: 7rem 10%;
  background: linear-gradient(135deg, #0d1020, #151a2d, #1d2340, #14182b);
  background-size: 300% 300%;
  animation: ${gradientAnimation} 12s ease-in-out infinite;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 3rem;

  @media (max-width: 992px) {
    flex-direction: column;
    text-align: center;
  }
`;

const LeftLottieContainer = styled(motion.div)`
  flex: 1;
  display: flex;
  justify-content: center;

  .lottie {
    width: 420px;
    filter: drop-shadow(0 22px 40px rgba(0, 0, 0, 0.45));
  }
`;

const RightContent = styled(motion.div)`
  flex: 1;
  color: white;
`;

const Title = styled.h2`
  font-size: 2.8rem;
  font-weight: 700;
  margin-bottom: 1rem;

  span {
    background: linear-gradient(90deg, #9e6aff, #643bff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const Subtitle = styled.p`
  font-size: 1.15rem;
  color: #cfd2e6;
  max-width: 500px;
  margin-bottom: 2rem;
  line-height: 1.7;
  opacity: 0.9;
`;

const BulletList = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 2.5rem;

  li {
    font-size: 1rem;
    margin-bottom: 0.7rem;
    color: #bfc4d8;
  }
`;

const CTAButtons = styled.div`
  display: flex;
  gap: 1rem;
`;

const PrimaryCTA = styled.a`
  background: linear-gradient(90deg, #643bff, #8f5bff);
  padding: 0.9rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  color: white;
  text-decoration: none;
`;

const SecondaryCTA = styled.a`
  padding: 0.9rem 2rem;
  border-radius: 12px;
  color: #cfd3e8;
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-decoration: none;
`;

export default AppShowcase;
